import { CheckboxField } from "../DynamicFormTypes";
import { Controller, useFieldArray, UseFormReturn, } from "react-hook-form";
import { Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, Stack } from "@mui/material";
import { ChangeEvent } from "react";
import { colours } from "../../../StyleConstants";

type Props = {
    field: CheckboxField;
    form: UseFormReturn;
}

const CheckboxInput = ({ field, form }: Props) => {
    const { name, label, validationRules, options = [], numRows = 1,numColumns = 1 } = field;
    const { errors } = form.formState;
    const { append, remove } = useFieldArray({ control: form.control, name });

    const defaultValues = options
        .filter((option) => option.defaultSelected)
        .map((option) => option.value);
    const handleChange = (e: ChangeEvent<HTMLInputElement> ) => {
        const value = e.target.value;
        const indexOfValue = form.control._getFieldArray(name).findIndex(x => value === x);
        if(indexOfValue !== -1) {
            remove(indexOfValue);
        }else {
            append(value);
        }
    }

    return (
        <FormControl error={name in errors} required={true} sx={{ alignSelf: 'flex-start' }}>
            <FormLabel>{label}</FormLabel>
            {name in errors &&
            //@ts-ignore
            <FormHelperText>{errors[name]?.root?.message.toString() ||  "This field is required."}</FormHelperText>}
            <Controller
                control={form.control}
                name={name}
                rules={validationRules}
                defaultValue={defaultValues}

                render={({ field }) =>
                    <Stack sx={{
                        display: 'grid',
                        gridTemplateRows: `repeat(${numRows}, minmax(auto, max-content))`,
                        gridTemplateColumns: `repeat(${numColumns}, minmax(auto, max-content))`,
                    }}>
                        {options.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                control={
                                    <Checkbox
                                        {...field}
                                        disabled={option.disabled || false}
                                        onChange={handleChange}
                                        checked={form.control._getFieldArray(name).includes(option.value)}
                                        value={option.value}
                                        sx={{
                                            color: colours.orange.orange,
                                            "&.Mui-checked" : { color: colours.orange.orange }
                                        }}
                                    />
                                }
                                label={option.label}
                            />
                        ))}
                    </Stack>
                }/>
        </FormControl>
    );
};

export default CheckboxInput;